import { getMsalInstance, isMsalConfigured } from "./msalInstance";

const ERROR_KEY = "koc.microsoft-login-error";
const API_BASE = process.env.REACT_APP_API_URL;

// De foutmelding overleeft de volledige page-redirect naar Microsoft en terug
// via sessionStorage; de LoginPage leest hem eenmalig uit.
export const storeMicrosoftLoginError = (message: string): void => {
  try {
    sessionStorage.setItem(ERROR_KEY, message);
  } catch {
    // sessionStorage kan geblokkeerd zijn (private mode); dan geen melding
  }
};

export const takeMicrosoftLoginError = (): string | null => {
  try {
    const message = sessionStorage.getItem(ERROR_KEY);
    if (message) sessionStorage.removeItem(ERROR_KEY);
    return message;
  } catch {
    return null;
  }
};

// Rondt een terugkeer van de Microsoft-login-redirect af vóórdat React rendert.
// Doordat de router nog niet bestaat kan die de auth-response niet uit de URL
// navigeren, en zonder popupvenster is er niets dat een popup-blocker of
// browserspecifieke timing kan breken.
export const completeMicrosoftRedirect = async (): Promise<void> => {
  if (!isMsalConfigured()) return;

  let idToken: string | undefined;
  try {
    const msal = await getMsalInstance();
    const result = await msal.handleRedirectPromise();
    idToken = result?.idToken;
  } catch (error: any) {
    // access_denied = gebruiker heeft zelf geannuleerd bij Microsoft
    if (!String(error?.errorCode || "").includes("access_denied")) {
      storeMicrosoftLoginError(
        error?.errorMessage ||
          error?.message ||
          "Microsoft login mislukt. Probeer het opnieuw.",
      );
    }
    return;
  }

  if (!idToken) return;

  try {
    const res = await fetch(`${API_BASE}/auth/microsoft`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ idToken }),
    });
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      storeMicrosoftLoginError(
        data.message || "Microsoft login mislukt. Probeer het opnieuw.",
      );
    }
  } catch {
    storeMicrosoftLoginError(
      "Kon de server niet bereiken. Controleer je verbinding en probeer het opnieuw.",
    );
  }
};
